<template>
  <div>
      <div :class="['pricing-area', getResponsiveMenuStatus  ? 'pricing-area-mobile' : '']" v-if="showPricingBtn && getCurrentLanguage() !== 'tr'">
        <img src="../../assets/hrVenue/pricing.svg" alt="pricing" />
        <h3>{{ resource["sidebar.pricingTitle"] }}</h3>
        <p>{{ resource["sidebar.pricingDescription"] }}</p>
        <button
          class="bg-purple text-white"
          id="seePlans"
          @click="seePlans"
        >
          {{ resource["navbar.pricingButton"] }}
        </button>
      </div>
      <!-- <b-nav-item-dropdown
        v-if="currentUser.closingDayCount !== 0 && currentUser.companyType !== 0"
        v-authenticate="{
            status:'disabled',
            methods:['question.create','job.kvkk','message.write']
        }"
        no-caret
        class="settings-dropdown mr-sm-3 mr-3"
        right
        >
        <template slot="text">
            <b-button
            id="settingsButton"
            class="settings-button"
            name="settings"
            >
            <i class="icon icon-settings" />
            </b-button>
        </template>
        <div role="group">
            <b-dropdown-header>
            <b>{{ resource['view.GeneralSettings'] }}</b>
            </b-dropdown-header>
            <b-dropdown-item
            v-authenticate="{status:'hide',method:'question.create'}"
            name="job-questions"
            :to="{name:'JobQuestionsView'}"
            class="no-border"
            >
            {{ resource['view.JobQuestions'] }}
            </b-dropdown-item>
            <b-dropdown-item
            v-if="!isCompanyBasic"
            name="quick-messages"
            :to="{name:'SettingsMessagesView'}"
            class="no-border"
            >
            {{ resource['view.QuickMessages'] }}
            </b-dropdown-item>
            <b-dropdown-item
            v-if="currentUser.companyType !== 0"
            v-authenticate="{status:'hide',method:'job.kvkk'}"
            name="kvkk"
            :to="{name: 'KvkkView'}"
            class="no-border"
            >
            {{ resource['view.Kvkk.Module'] }}
            </b-dropdown-item>
        </div>
      </b-nav-item-dropdown> -->
      <b-nav-item-dropdown
        right
        class="username-dropdown ug-sidebarfooter"
        @shown="footerShow"
        @hidden="footerHide"
        >
        <template slot="text">
            <span class="rounded-circle">{{ getShortName(currentUser.fullname.toLocaleUpperCase('TR')) }}</span>
            <span class="username-dropdown_user-info">{{ resource['sidebar.myAccount'] }}</span>
        </template>
        <!-- <b-dropdown-header>
            {{ resource['navbar.UserSettings.HeaderText'] }}
        </b-dropdown-header> -->
        <!-- <div role="group">
            <b-dropdown-header>
            <b>{{ currentUser.fullname.toUpperCase() }}</b>
            </b-dropdown-header>
            <b-dropdown-item
            :to="{name:'MyAccountView'}"
            class="no-border myAccount"
            @click.native="footerItemClicked({name:'MyAccountView', text: 'myAccount.Tab'})"
            >
            {{ resource['myAccount.Tab'] }}
            </b-dropdown-item>
            <b-dropdown-item
            v-if="!isRestrictedUser && currentUser.hasExcelRight
                && isCompanyAdvanceOrPro"
            v-authenticate="{status:'hide' , method:'resume.exceldownload'}"
            :to="{name:'DownloadListView'}"
            class="no-border downloadTab"
            @click.native="footerItemClicked({name:'DownloadListView', text: 'download.Tab'})"
            >
            {{ resource['download.Tab'] }}
            </b-dropdown-item>
        </div> -->
        <div role="group">
            <!-- <b-dropdown-header>
              {{ currentUser.companyName || "Company Name" }}
            </b-dropdown-header> -->
            <b-dropdown-item
            v-authenticate="{status:'hide',method:'profile.list'}"
            class="myProfile"
            :to="{name:'MyAccountView', params: { lang: $route.params.lang }}"
            @click.native="footerItemClicked({name:'MyAccountView', text: 'myAccount.Profile'})"
            >
              {{ resource['myAccount.Profile'] }}
            </b-dropdown-item>
            <b-dropdown-item
            v-authenticate="{status:'hide',method:'profile.list'}"
            class="UserListView"
            :to="{name:'UserListView', params: { lang: $route.params.lang }}"
            @click.native="footerItemClicked({name:'UserListView', text: 'myAccount.User'})"
            >
              {{ resource['myAccount.User'] }}
            </b-dropdown-item>
            <b-dropdown-item
            v-authenticate="{status:'hide',method:'profile.list'}"
            class="MySubscriber"
            :to="{name:'SubscriptionInformationView', params: { lang: $route.params.lang }}"
            @click.native="footerItemClicked({name:'MySubscriber', text: 'myAccount.MySubscriber'})"
            >
              {{ resource['myAccount.mySubscriber'] }}
            </b-dropdown-item>
            <b-dropdown-item
            :to="{name:'FaqList', params: { lang: $route.params.lang }}"
            class="FaqList"
            @click.native="footerItemClicked({name:'FaqList', text: 'sidebar.Faq'})"
            >
            {{ resource['sidebar.Faq'] }}
            </b-dropdown-item>
            <!-- <b-dropdown-item
            v-if="currentUser.isSuperAdmin && currentUser.isHolding
                && isCompanyAdvance && isUserAdminOrCRM"
            v-authenticate="{status:'hide',method:'profile.list'}"
            class="companyGroupList"
            :to="{name:'CompanyGroupList'}"
            >
            {{ resource['view.CompanyGroupList'] }}
            </b-dropdown-item> -->
        </div>
        <a
          :class="['logout logoutButton dropdown-item no-border',
                    'text-color-dark-pink d-flex align-items-center']"
          href="javascript:;"
          tabindex="-1"
          role="menuitem"
          @click="logout"
          id="logoutButton"
        >
              <i class="icon icon-logout" />
              <p>{{ resource['label.Logout'] }}</p>
        </a>
      </b-nav-item-dropdown>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import AccountService from '@/services/account';
import { serviceWrapper, serviceConfigs } from '@/services/configs';
import hrvenueService from '../../services/hrvenue.service';
import ResourceManager from '../../services/resource.service';

export default {
  name: 'SideBarFooter',

  data() {
    return {
      showPricingBtn: false,
    };
  },

  async created() {
    if (this.isAuth) {
      const stripeIsActive = await hrvenueService.getSettingKey('FeatureManagement:Stripe');
      this.showPricingBtn = stripeIsActive === 'True';
    }
  },

  computed: {
    ...mapGetters([
      'getNavMenuCloseIcon',
      'getResponsiveMenuStatus',
    ]),

    companyName() {
      return this.currentUser.name.replace(/&nbsp;/g, ' ');
    },

    isUserAdminOrCRM() {
      const { companyUserRoleId, isCrmUser } = this.currentUser;
      return companyUserRoleId === 1 || isCrmUser;
    },

    isRestrictedUser() {
      return (
        this.currentUser.companyUserRoleId === 4
        || this.currentUser.companyUserRoleId === 7
      );
    },

    isAuth() {
      return AccountService.checkAuth();
    },
  },

  methods: {
    ...mapActions([
      'changeUserFilterModel',
      'changeWorkGroupFilterModel',
      'changeCreatedCompanyUserId',
      'changeWorkGroupId',
    ]),
    footerItemClicked(item) {
      dataLayer.push({
        event: 'gaEvent',
        Category: 'menu_click',
        Action: this.resource['myAccount.Info'],
        Label: this.resource[item.text],
      });
    },
    footerShow() {
      if (!this.getNavMenuCloseIcon) {
        this.setNavMenuCloseIcon(true);
      }
    },
    footerHide() {
      const isNotificationShow = document.querySelector('.notification-center > ul').className.includes('show');
      if (!isNotificationShow) {
        this.setNavMenuCloseIcon(false);
        this.setResponsiveMenuStatus(false);
      }
    },
    ...mapMutations(['setNavMenuCloseIcon', 'setResponsiveMenuStatus']),
    logout () {
      serviceWrapper(
        serviceConfigs.account,
        serviceConfigs.account.logOut,
        {},
      )
        .then((response) => {
          if (response.data.body.isSuccess === true) {
            AccountService.reset2fa();
            // delete token from cookie
            AccountService.deleteToken();

            ResourceManager.Get().then((res) => {
              this.callSetResource({
                ...res,
                CurrentLang: 'en-US',
              });
            });
            const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

            this.$router.push({ name: 'LoginView', params: { lang } });
            window.location.reload();
          }
        });
    },

    getShortName(value) {
      let shortName = '';

      if (value) {
        // create name array
        // eslint-disable-next-line no-param-reassign
        value = value.trim().split(' ');
        // create short first char
        if (value[0]) shortName += value[0].substr(0, 1);
        if (value[1]) shortName += value[1].substr(0, 1);
        return shortName;
      }
    },

    seePlans() {
      this.setNavMenuCloseIcon(false);
      this.setResponsiveMenuStatus(false);
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'see_plans_click',
        page_type: 'home/dashboard',
        site_type: 'interview',
      });
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({
        name: 'PricingListView',
        params: {
          lang,
        },
      });
    },
    getCurrentLanguage() {
      return this.$route.params.lang;
    },
  },
};
</script>
<style lang="scss">
@import "~@/style/starter.scss";
.sidebarnew{
.username-dropdown {
  position: absolute;
  width: 232px;
  height: 48px;
  bottom: 8px;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0 !important;
  @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
    right: 16px;
    left: inherit;
    width: 65px;
    bottom: inherit;
    top: 4px;
    height: 40px;
  }
  &_user-info {
    font-weight: 700;
    font-size: 14px;
    line-height: 48px;
    color: $white;
    @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
      display: none !important;
    }
  }
  &:before {
    display: none;
    content: "";
    position: absolute;
    right: -4px;
    top: 50%;
    margin-top: -10px;
    border-top: 9px solid transparent;
    border-bottom: 9px solid transparent;
    border-right: 9px solid $white;
  }
  &:hover {
    &:after {
      content: "";
      position: absolute;
      border-radius: 0.5rem;
      background: $transparent-colors-nav-hover-bg;
      width: 100%;
      height: 100%;
      z-index: -1;
    }

    span {
      color: $white;
    }
  }
  &.show {
    &:before {
      display: block;
      @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
        display: none !important;
      }
    }
    &:after {
      content: "";
      position: absolute;
      border: 1px solid rgba(255, 255, 255, .4);
      @include border-radius(8px);
      border-radius: 0.5rem;
      border: 1px solid #858585;
      width: 100%;
      height: 100%;
      z-index: -1;
    }
    span {
      color: $white;
    }
    >a {
      // &:before {
      //   content: "\e99a";
      // }
      &:after {
        content: "\e915";
        @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
          content: "\e932";
        }
      }
    }
  }
  >a {
    display: flex !important;
    flex-direction: row !important;
    width: 100%;
    height: 48px;
    outline: none;
    @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
      width: auto;
      height: auto;
      right: 0;
      top: 0;
      overflow: inherit !important;
    }
    // &:before {
    //   font-family: "ats-icon";
    //   content: "\e99c";
    //   font-size: 17px;
    //   color: $white;
    //   position: absolute;
    //   left: 10px;
    // }
    &:after {
      font-family: "ats-icon";
      content: "\e920";
      font-size: 9px;
      color: $white;
      margin: 0 !important;
      border: none;
      position: absolute;
      right: 15px;
      bottom: 30px;
      @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
        right: -12px;
        content: "\e930";
        line-height: 32px;
      }
    }
  }
  .rounded-circle {
    font-weight: 700;
    font-size: 14px;
    line-height: 32px;
    vertical-align: text-top;
    color: $dusk;
    background-color: $white;
    margin-left: 8px;
    margin-right: 8px;
  }
  .dropdown-menu {
    width: 100px;
    min-width: 100px;
    // height: 497px;
    display: block !important;
    position: absolute;
    margin: 0 0 0 236px;
    left: 0 !important;
    top: inherit !important;
    bottom: 3px;
    transform: none !important;
    visibility: hidden;
    background-color: #F5F5F5;
    border: 1px solid #E4E4E4;
    @include border-radius(4px);
    @include box-shadow(0px 0px 12px rgba(0, 0, 0, 0.25));
    @include opacity(0);
    @include transition (all, 0.2s, ease);
    @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
      position: fixed !important;
      top: 47px !important;
      height: 0 !important;
      max-height: 100%;
      width: 100% !important;
      margin: 0 !important;
      @include opacity(1);
      overflow: hidden;
      @include border-radius(0);
      > div {
        max-width: 100%;
      }
    }
    &.show {
      width: 244px;
      visibility: visible;
      @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
        height: calc(100% - 47px) !important;
      }
      @include opacity(1);
      @include transition (all, 0.2s, ease);
    }
  }
  .dropdown-item {
    padding: 9px 8px 9px 44px !important;
    display: flex;
    align-items: center;
    line-height: 1;
    font-weight: 400;
    font-size: 14px !important;
    color: #595959 !important;
    &:hover {
      background-color: #E4E4E4;
    }
  }
  //kullanıcı bilgilerim - toplu data aktarım - sıkça sorulan sorular
  .myAccount,
  .downloadTab,
  .faq {
    .dropdown-item {
      font-style: normal;
      color: #1D1D1D !important;
      padding-left: 14px !important;
      &:before {
        font-family: "ats-icon";
        content: "\e99a";
        font-size: 20px;
        margin-right: 10px;
      }
    }
  }
  .downloadTab {
    .dropdown-item {
      &:before {
        content: "\e999";
      }
    }
  }
  .faq {
    @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
      position: absolute;
      bottom: 77px;
      width: 100%;
      border-top: 1px solid #E4E4E4;
    }
    .dropdown-item {
      &:before {
        content: "\e998";
      }
    }
  }
  .dropdown-header {
    padding: 8px 8px 8px 24px;
    font-style: normal;
    font-weight: 700;
    color: $dusk !important;
    font-size: 16px !important;
    border-top: 1px solid #E4E4E4;
  }
  .logout {
    display: flex;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    color: #DE4747 !important;
    padding: 8px 8px 8px 24px !important;
    border-top: 1px solid #E4E4E4;
    @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
      position: absolute;
      bottom: 0;
      padding-bottom: 35px;
      width: 100%;
    }
    &:hover {
      background-color: #E4E4E4;
    }

    i {
      font-size: 24px;
      margin-right: 8px;
    }
  }
}
}

.pricing-area {
  position: absolute;
  bottom: 72px;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 216px;
  padding: 16px;
  background: #2F2F2F;
  border-radius: 20px;
  border: 1px solid rgba(217, 217, 217, 0.10);

  @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
    display: none;
  }

  &-mobile {
    @media only screen and (max-width: map-get($grid-breakpoints, 'lg')) {
      display: flex;
      position: fixed;
      bottom: 24px;
    }
  }

  h3 {
    color: #F8F8F8;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    margin: 8px 0 4px;
  }

  p {
    color: #666666;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin-bottom: 16px;
  }

  button {
    width: 100%;
    display: flex;
    padding: 6px 16px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    border-radius: 44px;
  }
}
</style>
